//@author: devin
import { Item } from "../../pojo/Item";

export namespace ItemUtil {
    export type SupportedItemType =
        | Item.Ids.Event
        | Item.Ids.Organization
        | Item.Ids.Contact
        | Item.Ids.Location
        | Item.Ids.Resource
        | Item.Ids.Task
        | Item.AvailabilityItemTypeId;
    export const SupportedItemTypes: Array<SupportedItemType> = [
        Item.Ids.Event,
        Item.Ids.Organization,
        Item.Ids.Contact,
        Item.Ids.Location,
        Item.Ids.Resource,
        Item.Ids.Task,
        Item.AvailabilityItemTypeId,
    ];

    export const IconStyles: Record<number, string> = {
        [Item.Ids.Event]: "icon-event",
        [Item.Ids.Organization]: "icon-org",
        [Item.Ids.Contact]: "icon-contact",
        [Item.Ids.Location]: "icon-space",
        [Item.Ids.Resource]: "icon-resource",
        [Item.Ids.Task]: "icon-task-active",
        [Number("1" + Item.Ids.Event)]: "icon-event",
        [Number("1" + Item.Ids.Location)]: "icon-space",
        [Number("1" + Item.Ids.Resource)]: "icon-resource",
        [Number(Item.Ids.Event + "0001")]: "icon-event",
        [Number(Item.Ids.Event + "0002")]: "icon-event",
        [Number(Item.Ids.Event + "0003")]: "icon-event",
        [Number(Item.Ids.Event + "0004")]: "icon-event",
    };
}
